module.exports = __webpack_public_path__ + "static/img/挂号.4fc3ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apphome/挂号.png
// module id = pOAb
// module chunks = 1